__turbopack_context__.v({
  "SingleChooser": "sun_NG_SingleChooser",
  "SingleChooser--Active": "sun_NG_SingleChooser--Active",
  "SingleChooser--AlignMenuRight": "sun_NG_SingleChooser--AlignMenuRight",
  "SingleChooser--AlignRight": "sun_NG_SingleChooser--AlignRight",
  "SingleChooser--Alternative": "sun_NG_SingleChooser--Alternative",
  "SingleChooser--Border": "sun_NG_SingleChooser--Border",
  "SingleChooser--SecondaryActive": "sun_NG_SingleChooser--SecondaryActive",
  "SingleChooser--Tiny": "sun_NG_SingleChooser--Tiny",
  "SingleChooser--Wide": "sun_NG_SingleChooser--Wide",
  "SingleChooser__Clear": "sun_NG_SingleChooser__Clear",
  "SingleChooser__Container": "sun_NG_SingleChooser__Container",
  "SingleChooser__Icon": "sun_NG_SingleChooser__Icon",
  "SingleChooser__Menu": "sun_NG_SingleChooser__Menu",
  "SingleChooser__Option": "sun_NG_SingleChooser__Option",
  "SingleChooser__Option--Secondary": "sun_NG_SingleChooser__Option--Secondary",
  "SingleChooser__OptionButton": "sun_NG_SingleChooser__OptionButton",
  "SingleChooser__OptionButton--Active": "sun_NG_SingleChooser__OptionButton--Active",
  "SingleChooser__OptionButton--Clear": "sun_NG_SingleChooser__OptionButton--Clear",
  "SingleChooser__OptionButton--Secondary": "sun_NG_SingleChooser__OptionButton--Secondary",
  "SingleChooser__Options": "sun_NG_SingleChooser__Options",
  "SingleChooser__SecondaryIcon": "sun_NG_SingleChooser__SecondaryIcon",
  "SingleChooser__SelectedValue": "sun_NG_SingleChooser__SelectedValue",
  "SingleChooser__Toggler": "sun_NG_SingleChooser__Toggler",
  "SingleChooser__Tooltip": "sun_NG_SingleChooser__Tooltip",
  "SingleChooser__Tooltip--Hidden": "sun_NG_SingleChooser__Tooltip--Hidden",
  "SingleChooser__TooltipButton": "sun_NG_SingleChooser__TooltipButton",
});
